import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Sku from '@/assets/icons/fulfill/icon-sku.svg';
import Cost from '@/assets/icons/fulfill/ilustracion_carga_costo.svg';
import Photo from '@/assets/icons/fulfill/ilustracion_carga_foto.svg';
import Measures from '@/assets/icons/fulfill/ilustracion_carga_medidas.svg';
import Product from '@/assets/icons/fulfill/ilustracion_carga_producto.svg';
import Button from '@/components/Button';
import useResponsive from '@/hooks/useResponsive';

import { AddProductStepProps } from './AddProductStepOne';

// TODO: TESTEAR SI FUNCIONA.
interface FieldsCardsProps {
  icon: string;
  title: string;
  index: number;
  children: React.ReactNode | string;
}
const cards = [
  {
    icon: Product,
    title: 'En Name:',
    description: 'Ingresa el nombre del producto',
  },
  {
    icon: Photo,
    title: 'En Thumbnail:',
    description: 'Inserta el enlace (URL) de la imagen del producto',
  },
  {
    icon: Cost,
    title: 'En Value & Price:',
    description: (
      <>
        <strong>Value:</strong> Valor de venta del producto cliente final (número sin símbolos)
        <br />
        <strong>Price:</strong> Valor de compra del producto(número sin símbolos) *opcional
      </>
    ),
  },
  {
    icon: Measures,
    title: 'En Weight, Height, Width & Length:',
    description: 'Ingresa las medidas del producto (solo número en cm o g)',
  },
  {
    icon: Sku,
    title: 'SKU:',
    description: 'Obligatorio y debe ser único.',
  },
  {
    icon: Measures,
    title: 'Barcode:',
    description: 'Opcional, si se incluye, debe ser único.',
  },
];

const AddProductStepTwo = ({
  step,
  setCurrentStep,
  urlTemplate,
  isPendingTemplate,
}: AddProductStepProps) => {
  const theme = useTheme();
  const isSmallDrawer = useResponsive('between', 'lg', 'xl');
  const isPhone = useResponsive('down', 'sm');
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          margin: '1rem 0',
          [theme.breakpoints.between('lg', 'xl')]: {
            flexDirection: 'column',
            gap: '1rem',
          },
          [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: '1rem',
          },
        }}
      >
        <Typography variant="subtitle1" sx={{ minWidth: '4.4rem' }}>
          Paso <span style={{ color: theme.palette.primary.main }}>2</span>
        </Typography>
        <Divider
          orientation={isSmallDrawer || isPhone ? 'horizontal' : 'vertical'}
          flexItem
          sx={{
            margin: isSmallDrawer || isPhone ? '0' : `0 ${theme.spacing(2)}`,
          }}
        />
        <Box>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.grey[600],
              '&& span': { color: theme.palette.primary.main },
            }}
          >
            <span>Tienes disponible una plantilla</span> para facilitarte la carga de tu catálogo
            <br />
            Una vez que la descargues, completa los campos pre-definidos por cada nuevo producto:
          </Typography>
        </Box>
      </Box>
      <Divider flexItem sx={{ margin: `${theme.spacing(2)} 0`, width: '100%' }} />

      <Grid container spacing={2}>
        {cards.map((card, index) => (
          <Grid key={index} size={{ xxs: 12, sm: 6, md: 4, lg: 6, xxl: 4 }}>
            <FieldsCards key={index} icon={card.icon} index={index} title={card.title}>
              {card.description}
            </FieldsCards>
          </Grid>
        ))}
      </Grid>
      <Grid
        size={12}
        container
        sx={{
          display: 'flex',
          justifyContent: 'center',
          margin: '1rem auto',
        }}
      >
        <Button
          variant="outlined"
          disabled={isPendingTemplate}
          onClick={() => window.open(urlTemplate!, '__blank')}
        >
          Descargar plantilla
        </Button>
      </Grid>
      <Grid
        size={12}
        container
        sx={{
          display: 'flex',
          justifyContent: 'center',
          margin: '1rem auto',
        }}
      >
        <Typography variant="body2" color={theme.palette.grey[900]}>
          Una vez completado, recuerda guardar el archivo con <strong>la extensión .CSV.</strong>
        </Typography>
      </Grid>
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: { xxs: 'column-reverse', sm: 'row', lg: 'column-reverse', xl: 'row' },
          justifyContent: { xxs: 'center', sm: 'space-between', lg: 'center', xl: 'space-between' },
          width: '100%',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <Button variant="outlined" onClick={() => setCurrentStep(step - 1)}>
          Atras
        </Button>
        <Button onClick={() => setCurrentStep(step + 1)}>Subir CSV</Button>
      </Grid>
    </>
  );
};

export default AddProductStepTwo;

const FieldsCards = ({ icon, children, title, index }: FieldsCardsProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xxs: 'column', md: 'row', lg: 'column', xl: 'row' },
        alignItems: { xxs: 'flex-start', md: 'center', lg: 'flex-start', xl: 'center' },
        gap: '1rem',
        height: '100%',
        padding: '1rem',
        boxSizing: 'border-box',
      }}
    >
      <img
        style={{ width: index === 2 ? '23px' : '43px', maxWidth: '100%', height: 'auto' }}
        src={icon}
        alt={`icon-${index}`}
      />
      <Box sx={{ fontSize: '0.9rem' }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          {title}
        </Typography>
        <Typography variant="body2">{children}</Typography>
      </Box>
    </Box>
  );
};
